<div style="margin-top: 1em">


  <p-card header="Проверьте введённые вами данные перед отправкой" *ngIf="isFormReady">

    <ng-container *ngIf="thesesResource.mainAuthor">
      <h4>Главный автор</h4>
      <p> {{
        thesesResource.mainAuthor.lastName +
        " " +
        thesesResource.mainAuthor.firstName
        }}
        <span *ngIf="thesesResource.mainAuthor.middleName !== null">
          {{ thesesResource.mainAuthor.middleName }}
        </span>
      </p>
    </ng-container>

    <ng-container *ngIf="
    thesesResource.mainAuthor.workplace !== '' &&
    thesesResource.mainAuthor.workplace !== null
  ">
      <h4>Место работы</h4>
      <p>{{ thesesResource.mainAuthor?.workplace }}</p>
    </ng-container>

    <ng-container *ngIf="
    thesesResource.mainAuthor.contactEmail !== '' &&
    thesesResource.mainAuthor.contactEmail !== null
  ">
      <h4>E-mail адрес</h4>
      <p>{{ thesesResource.mainAuthor?.contactEmail }}</p>
    </ng-container>

    <ng-container *ngIf="thesesResource.otherAuthor.length !== 0">
      <h4>Другие авторы</h4>
      <ol>
        <li *ngFor="let author of thesesResource.otherAuthor; let idx = index">
          {{
          author?.lastName + " " + author?.firstName + " " + author?.middleName
          }}
          <i *ngIf="author.workplace !== ''">
            (Место работы: {{ author?.workplace }})
          </i>
        </li>
      </ol>
    </ng-container>

    <h4>Название</h4>
    <div [innerHtml]="thesesResource.thesesTitle"></div>

    <h4>Цель</h4>
    <div [innerHtml]="thesesResource.thesesTarget"></div>

    <h4>Материалы и методы</h4>
    <div [innerHtml]="thesesResource.thesesMaterials"></div>

    <h4>Результаты</h4>
    <div [innerHtml]="thesesResource.thesesResults"></div>

    <h4>Выводы</h4>
    <div [innerHtml]="thesesResource.thesesConclusions"></div>

    <ng-template pTemplate="footer">
      <div class="flex flex-row align-items-center justify-content-between mt-6">
        <p-button label="Назад" (onClick)="prevPage()" icon="pi pi-angle-left"></p-button>
        <p-button label="Отправить" (onClick)="sendData()" icon="pi pi-check" iconPos="right"></p-button>
      </div>
    </ng-template>

  </p-card>
</div>
